<template>
  <div>
    <div class="level">
      <div class="level-left">
        <router-link
          class="button is-info is-small"
          :to="{ name: 'Create Sales Quote' }"
        >
          <span class="icon"> <i class="fas fa-plus"></i> </span>&nbsp; Create
          new</router-link
        >
        &nbsp;
        <button class="button is-small" @click="refreshTable()">Refresh</button>
      </div>
      <div class="level-right">
        <b-select size="is-small" v-model="perPage">
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="15">15 per page</option>
          <option value="20">20 per page</option>
          <option value="100">100 per page</option>
          <option value="200">200 per page</option>
          <option value="300">300 per page</option>
          <option value="1000">1000 per page</option>
        </b-select>
      </div>
    </div>
    <table-pagination
      :tableData="salesQuotes.data"
      :bordered="true"
      :striped="true"
      :narrowed="true"
      :search="search"
      :hoverable="true"
      :mobileCards="true"
      :loading="isLoadingTable"
      :page="page"
      :perPage="perPage"
      :totalData="salesQuotes.totalData"
      @onPageChanged="page = $event"
      @onSearchChanged="search = $event"
      @onPerPageChanged="perPage = $event"
    >
      <template slot="row-content" slot-scope="{ item }">
        <b-table-column
          class="table-column-content-is-small"
          label="Quotation #"
        >
          {{ item.row.quatationNumber }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Agent">
          {{ item.row.user }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Client">
          {{ item.row.client }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Date submitted"
        >
          {{ item.row.dateCreated }}
        </b-table-column>
        <!-- <b-table-column
          style="center"
          class="table-column-content-is-small"
          label="Email notif."
          centered
        >
          <p class="has-text-success" v-if="item.row.isSent">
            <span class="icon">
              <i class="fas fa-check"></i>
            </span>
          </p>
          <p class="has-text-danger" v-else>
            <span class="icon">
              <i class="fas fa-times"></i>
            </span>
          </p>
        </b-table-column> -->
        <b-table-column class="table-column-content-is-small" label=" ">
          <!-- <button
            class="button is-small is-info is-outlined"
            @click="sendToClientEmail(item.row.salesQuoteId)"
            :disabled="isSendingQuoteNotAvailable"
          >
            <span class="icon" title="Send to client's email">
              <i class="fa fa-paper-plane"></i> </span
            >&nbsp;(Unavailable)
          </button> -->
          &nbsp;
          <button
            v-if="appName == 'ANSI'"
            :class="buttonDownloadSalesQuote"
            @click="
              downloadPdf(
                item.row.salesQuoteId,
                item.row.client,
                item.row.user,
                item.row.quatationNumber,
                false
              )
            "
            title="Download PDF"
          >
            <span class="icon">
              <i class="far fa-file-pdf"></i>
            </span>
            &nbsp; Download PDF
          </button>
          <button
            v-else
            :class="buttonDownloadSalesQuote"
            @click="
              downloadPdf(
                item.row.salesQuoteId,
                item.row.client,
                item.row.user,
                item.row.quatationNumber,
                true
              )
            "
            title="Download ADAPTIVE Based PDF"
          >
            <span class="icon">
              <i class="far fa-file-pdf"></i>
            </span>
            &nbsp; Download PDF
          </button>
          &nbsp;
          <router-link
            class="button is-small is-warning"
            :to="{
              name: 'Edit Sales Quote',
              params: { salesQuoteId: item.row.salesQuoteId }
            }"
            >Edit</router-link
          >
          &nbsp;
          <button
            class="button is-small is-danger"
            @click="deleteSalesQuote(item.row.salesQuoteId)"
          >
            Delete
          </button>
        </b-table-column>
      </template>
    </table-pagination>
    <Delete />
    <span v-show="isSendingQuoteNotAvailable == false">
      <EmailToClient />
    </span>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";
import TablePagination from "../TablePagination.vue";
import EmailToClient from "./EmailToClient.vue";
import Delete from "./Delete.vue";
import AppToast from "../frontend/appToast";
import AppButton from "../frontend/appButton";
import { VueEditor } from "vue2-editor";

const appToast = new AppToast();
const appButton = new AppButton();

export default {
  components: {
    TablePagination,
    Delete,
    EmailToClient,
    VueEditor
  },
  mounted() {
    this.default();
  },
  computed: {
    ...mapState("salesquote", {
      salesQuotes: state => state.salesQuotes,
      isLoadingTable: state => state.isLoadingTable
    })
  },
  data: () => ({
    appName: process.env.VUE_APP_ANOTHER_VARIABLE,
    isSendingQuoteNotAvailable: true,
    isEmpty: false,
    page: 1,
    perPage: 10,
    search: "",
    buttonDownloadSalesQuote: appButton.isLoadingDefault(false)
  }),
  created() {
    const perPageFromRoute = this.$route.params.pageSize;
    const searchQueryFromRoute = this.$route.params.searchQuery;

    this.perPage = perPageFromRoute ? perPageFromRoute : 10;
    this.search = searchQueryFromRoute ? searchQueryFromRoute : "";
  },
  methods: {
    ...mapActions("salesquote", [
      "getPaginatedSalesQuotes",
      "openDeleteModal",
      "openEmailToClientModal"
    ]),
    refreshTable() {
      this.default();
    },
    sendToClientEmail(salesQuoteId) {
      if (this.isSendingQuoteNotAvailable == false) {
        this.openEmailToClientModal({
          showEmailToClientModal: true,
          salesQuoteForEmailToClient: {
            salesQuoteId: salesQuoteId
          }
        });
      }
    },
    downloadPdf(salesQuoteId, client, agentName, quotationNumber, isAdaptive) {
      if (salesQuoteId) {
        this.buttonDownloadSalesQuote = appButton.isLoadingDefault(true);
        axios
          .get(
            `downloadables/salesquote?id=${salesQuoteId}&isAdaptive=${isAdaptive}`,
            {
              responseType: "blob"
            }
          )
          .then(response => {
            console.log(response.data);
            const windowUrl = window.URL || window.webkitURL;
            const url = windowUrl.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `${client} ref${quotationNumber}.pdf`
            );
            document.body.appendChild(link);
            link.click();
          })
          .catch(error => {
            console.log(error);
          })
          .then(
            () =>
              (this.buttonDownloadSalesQuote = appButton.isLoadingDefault(
                false
              ))
          );
      }
    },
    default() {
      this.getPaginatedSalesQuotes({
        page: this.page,
        pageSize: this.perPage,
        query: this.search
      });
    },
    deleteSalesQuote(id) {
      this.openDeleteModal({
        showDeleteModal: true,
        salesQuote: {
          salesQuoteId: id
        }
      });
    }
  },
  watch: {
    perPage(val) {
      this.$router.push({
        name: "List of Sales Quote",
        params: {
          pageSize: !val ? 10 : val,
          searchQuery: !this.search ? null : this.search
        }
      });

      this.getPaginatedSalesQuotes({
        page: this.page,
        pageSize: val,
        query: this.search
      });
    },
    page(val) {
      this.getPaginatedSalesQuotes({
        page: val,
        pageSize: this.perPage,
        query: this.search
      });
    },
    search(val) {
      this.$router.push({
        name: "List of Sales Quote",
        params: {
          pageSize: this.perPage,
          searchQuery: !val ? null : val
        }
      });

      this.getPaginatedSalesQuotes({
        page: this.page,
        pageSize: this.perPage,
        query: val
      });
    }
  }
};
</script>
